import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guarantee } from '../data/content';
export function Guarantee() {
  return <section className="bg-night-panel" data-id="element-90" data-mp="1o33u6h0ytshr">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-20" data-id="element-91" data-mp="223ek9hugb31v">
        <div className="mx-auto max-w-2xl rounded-3xl border border-gold-soft/40 bg-night p-7 text-center sm:p-10" data-id="element-92" data-mp="221by58wf5u2f">
          <ShieldCheckIcon className="mx-auto h-9 w-9 text-gold-soft" aria-hidden="true" data-id="element-93" data-mp="19eqvvdeenxk3" />
          <h2 className="mt-5 font-display text-2xl font-semibold leading-tight text-parchment sm:text-3xl" data-id="element-94" data-mp="14g64m3h4so7s">
            {guarantee.title}
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/75" data-id="element-95" data-mp="1j6n6tp1lbi5q">
            {guarantee.body}
          </p>
          <p className="mt-5 font-display text-lg font-semibold italic text-gold-soft" data-id="element-96" data-mp="qnzqso1gatbi">
            {guarantee.claim}
          </p>
        </div>
      </div>
    </section>;
}